import { createContext } from "react";

const layoutContext = createContext({});

export const { Provider, Consumer } = layoutContext;

export default layoutContext;
